export default __webpack_public_path__ + "static/media/gembound.615c2b84.png";